import React, { Component } from 'react';
import { connect } from 'react-redux';
import HoverMap from './HoverMap';
import { PivotItem, Pivot } from 'office-ui-fabric-react/lib/Pivot';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import Filters from './panel/items/filters';
import Thresholds from './panel/items/thresholds';
import Stats from './panel/items/stats';
import LineStyles from './panel/items/LineStyles';

import * as actions from '../store/actions/';

import { buildStatsPlot, buildStatYear } from '../utilities/index';
import { Toggle } from 'office-ui-fabric-react';

class ChartPanel extends Component {
  render(){
    const { plot, editChartY, editTrace, plotIndex, hoverMap, setMap, filters, loadYears } = this.props;
    const { userFavorites } = filters;
    const { appliedFilters, favorites } = plot;
    const PIVOT_ITEMS = [
      <PivotItem key='item-1' itemIcon="Filter">
        <Filters
          loadYears={loadYears}
          filtersFetched={ this.props.filtersFetched }
          editTrace={ editTrace }
          setMap={ setMap }
          editChartY={editChartY}
          favorites={ favorites }
          userFavorites={ userFavorites || [] }
          toggleFavorites={ this.props.toggleFavorites }
          plotIndex={ this.props.plotIndex } 
          filters={ this.props.filters } 
          changeFilter={ this.props.changeFilter } 
          clearFilters={ this.props.clearFilters }
          plot={ this.props.plot } 
          showStats={ this.props.showStats }
          copyFilter={ this.props.copyFilter } 
          pasteFilter={ this.props.pasteFilter }
          copiedFilter={ this.props.copiedFilter } 
          setPlotData={ this.props.setPlotData }
          buildStatsPlot={ buildStatsPlot}
          buildStatYear={ buildStatYear }
          toggleDatum={ this.props.toggleDatum }
          applyFilters={ this.props.applyFilters } />
      </PivotItem>,
      <PivotItem key='item-2' itemIcon="StackedLineChart">
        <Stats
          plotIndex={ this.props.plotIndex }
          plot={ this.props.plot }
          changeFilter={ this.props.changeFilter }
          applyFilters={ this.props.applyFilters } />
      </PivotItem>,
      <PivotItem key='item-3' itemIcon="EditStyle">
        <LineStyles
          plotIndex={ this.props.plotIndex }
          plot={ this.props.plot }
          editTrace={ this.props.editTrace }
          editChartLineStyles={ this.props.editChartLineStyles } />
      </PivotItem>,
      <PivotItem key='item-4' itemIcon="LineSpacing">
        <Thresholds
          plotIndex={ this.props.plotIndex }
          saveThreshold={this.props.saveThreshold}
          plot={ this.props.plot } 
          updateSavedThreshold={ this.props.updateSavedThreshold }
          addThreshold={ this.props.addThreshold }
          editThreshold={ this.props.editThreshold }
          clearThresholds={ this.props.clearThresholds }
          removeThresholdFromFavorites={ this.props.removeThresholdFromFavorites }
          removeThreshold={ this.props.removeThreshold } />
      </PivotItem>
    ];

    if(appliedFilters.method === 'Multiple Alternative' || appliedFilters.method === 'Single Alternative'){
      PIVOT_ITEMS.splice(1, 1);
    };

    return ( 
      <div className='overflow-column'>
        <Callout hidden={!this.props.hoverMap} target="#type-dropdown-filter-list" isBeakVisible={false}>
          <HoverMap {...hoverMap}/>
        </Callout>
        <IconButton
          onClick={ () => this.props.confirmRemove() }
          // onClick={() => this.props.removeChart(this.props.plotIndex)}
          iconProps={{ iconName: 'RemoveFilter' }} 
          className='remove-chart'
          title="Remove Chart" 
          ariaLabel="Remove Chart" />
        <Pivot className='panel-pivot'>
          {
            PIVOT_ITEMS.map(item => item)
          }
        </Pivot>
        <div className='controls fixed-bottom'>
          <Toggle
            label='Display Legend'
            onText="On"
            offText="Off"
            checked={ plot.layout.showlegend }
            onChange={ (e, showlegend) => this.props.editChartLayout({showlegend}, plotIndex) }
          />
          <Toggle
            label="Adjust to Datum"
            onText="On"
            offText="Off"
            disabled={ !plot.datum }
            checked={ plot.useDatum }
            onChange={(e, checked) => {
                this.props.toggleDatum(checked, plotIndex);
            }}
          />
          <Toggle
            label='Lock Y Axis'
            onText="On"
            offText="Off"
            checked={ plot.layout.yaxis.fixedrange }
            onChange={ (e, fixedrange) => {
              this.props.editChartY({fixedrange}, plotIndex)
            }}
          />
        </div>
      </div>
    )
  }
};

const mapStateToProps = state => {
	return {
    applyingFilters: state.multi.applyingFilters,
    copiedFilter: state.multi.copiedFilter,
    filters: state.multi.filters,
    filtersFetched: state.multi.filtersFetched,
    hoverMap: state.multi.hoverMap,
  }
};

const mapDispatchToProps = dispatch => {
	return {
    setPlotData: (data, index) => dispatch(actions.setPlotData(data, index)),
    editChartLayout: (data, index) => dispatch(actions.editChartLayout(data, index)),
    editChartLineStyles: (changes, plotIndex, chartKey) => dispatch(actions.editChartLineStyles(changes, plotIndex, chartKey)),
    editTrace: (changes, plotIndex, chartKey) => dispatch(actions.editTrace(changes, plotIndex, chartKey)),
    showStats: (index) => dispatch(actions.showStats(index)),
    editThreshold: (changes, plotIndex, thresholdIndex) => dispatch(actions.editThreshold(changes, plotIndex, thresholdIndex)),
    addThreshold: (index) => dispatch(actions.addThreshold(index)),
    removeThreshold: (index, key) => dispatch(actions.removeThreshold(index, key)),
    removeChart: (index) => dispatch(actions.removeChart(index)),
    copyFilter: (copiedFilter) => dispatch(actions.setCopyFilter(copiedFilter)),
    pasteFilter: (pasteFilter, index) => dispatch(actions.pasteFilter(pasteFilter, index)),
    changeFilter: (changes, index, item) => dispatch(actions.changeFilter(changes, index, item)),
    applyFilters: (filters, index) => dispatch(actions.applyFilters(filters, index)),
    clearFilters: (index) => dispatch(actions.clearFilters(index)),
    clearThresholds: (index) => dispatch(actions.clearThresholds(index)),
    toggleFavorites: (index, bool) => dispatch(actions.toggleFavorites(index, bool)),
    toggleDatum: (useDatum, index) => dispatch(actions.toggleDatum(useDatum, index)),
    editChartY: (changes, index) => dispatch(actions.editChartY(changes, index)),
    setMap: (map) => dispatch(actions.setMap(map)),
    loadYears: (filters, index, pickedAlts) => dispatch(actions.loadYears(filters, index, pickedAlts)),
    saveThreshold: (threshold, plotIndex) => dispatch(actions.saveThreshold(threshold, plotIndex)),
    updateSavedThreshold: (threshold, plotIndex) => dispatch(actions.updateSavedThreshold(threshold, plotIndex)),
    removeThresholdFromFavorites: (threshold, plotIndex) => dispatch(actions.removeThresholdFromFavorites(threshold, plotIndex))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ChartPanel);


// WEBPACK FOOTER //
// ./src/components/ChartPanel.js